import { render, staticRenderFns } from "./create.vue?vue&type=template&id=51be2640&scoped=true"
import script from "./create.vue?vue&type=script&lang=ts"
export * from "./create.vue?vue&type=script&lang=ts"
import style0 from "./create.vue?vue&type=style&index=0&id=51be2640&prod&lang=scss"
import style1 from "./create.vue?vue&type=style&index=1&id=51be2640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be2640",
  null
  
)

export default component.exports